"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WelcomeToBlueElegance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="38793" id="a-place-to-call-home" ref={ref} className="relative w-full overflow-hidden bg-background py-20 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col-reverse gap-12 lg:flex-row lg:items-center lg:gap-20">
          {}
          <div className={`flex flex-col items-start lg:w-[55%] transition-all duration-1000 ease-out ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
            <div className="mb-6 inline-flex items-center gap-2 rounded-xl bg-accent px-3 py-1 text-sm font-medium text-primary tracking-wide">
              <Sparkles className="h-4 w-4" />
              <span>OHCQ License in-progress<br />Small assisted living home with personalized care</span>
            </div>

            <h1 className="font-serif text-5xl font-bold leading-[1.1] tracking-tight text-primary sm:text-6xl md:text-7xl lg:text-7xl">A Small, Personalized Assisted Living Home in Silver Spring, Montgomery County.</h1>

            <p className="mt-8 max-w-2xl font-sans text-lg leading-[1.8] text-muted-foreground md:text-xl">As a small assisted living home with personalized care, we offer dedicated assisted living in Silver Spring, Maryland and residential assisted living in Montgomery County for a maximum of five seniors. We provide a warm, safe environment with 24/7 support and home cooked meals, ensuring every resident receives the dedicated attention they deserve.</p>

            <div className="mt-10 flex flex-wrap gap-4">
              <Button asChild size="lg" className="h-14 rounded-full px-8 text-base bg-primary text-primary-foreground shadow-lg shadow-primary/10 transition-transform hover:scale-105">
                <Link to="/ScheduleATourPage">
                  Schedule a Tour
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>

              <Button asChild variant="ghost" size="lg" className="h-14 rounded-full px-8 text-base text-primary border border-primary/20 hover:bg-accent/50">
                <Link to="/CareServicesPage">Learn About Our Home</Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`relative flex items-center justify-center lg:w-[45%] transition-all duration-1000 ease-out delay-300 ${isVisible ? "scale-100 opacity-100" : "scale-95 opacity-0"}`}>
            {}
            <div className="absolute -right-4 top-1/2 -z-10 h-[120%] w-[120%] -translate-y-1/2 translate-x-10 scale-90 rounded-full bg-secondary/10 blur-3xl opacity-60" />
            
            {}
            <div className="absolute -bottom-10 -left-10 -z-10 h-40 w-40 rounded-full bg-accent blur-2xl opacity-80" />

            <div className="relative">
              <div className="absolute -inset-1 rounded-tl-[120px] rounded-br-[120px] rounded-tr-3xl rounded-bl-3xl bg-gradient-to-br from-white/60 to-transparent opacity-40 blur-sm" />
              <img src="https://optimal-muskrat.10web.cloud/wp-content/uploads/2026/03/IMG_3641-scaled.jpg" alt="A small assisted living home with personalized care offering assisted living in Silver Spring, Maryland with a warm, family-like atmosphere" className="relative z-10 aspect-[4/5] w-full max-w-md rounded-tl-[120px] rounded-br-[120px] rounded-tr-3xl rounded-bl-3xl object-cover shadow-2xl shadow-primary/5" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}